// src/components/BlogSection.js
import React, { useContext } from 'react';
import { BlogContext } from '../BlogContext';
import { Link } from 'react-router-dom';

const BlogSection = () => {
  const { loading, getPublicPosts } = useContext(BlogContext);
  const publicPosts = getPublicPosts();

  if (loading) {
    return (
      <section id="blog-preview" className="my-16">
        <h2 className="text-2xl font-bold text-white text-center mb-4">
          My Digital Sanctuary
        </h2>
        <p className="text-center text-gray-300 mb-8">Where I share my authentic thoughts, company updates, and tech explorations</p>
        <p className="text-center text-gray-300">Loading blog posts...</p>
      </section>
    );
  }

  if (!publicPosts || publicPosts.length === 0) {
    return (
      <section id="blog-preview" className="my-16">
        <h2 className="text-2xl font-bold text-white text-center mb-4">
          My Digital Sanctuary
        </h2>
        <p className="text-center text-gray-300 mb-8">Where I share my authentic thoughts, company updates, and tech explorations</p>
        <p className="text-center text-gray-300">No blog posts available yet - but exciting content is coming soon!</p>
      </section>
    );
  }

  // Sort posts by createdAt (if available) or by id descending as fallback.
  const sortedPosts = publicPosts.slice().sort((a, b) => {
    if (a.createdAt && b.createdAt) {
      return new Date(b.createdAt) - new Date(a.createdAt);
    }
    return b.id - a.id;
  });

  // Get the two most recent posts
  const recentPosts = sortedPosts.slice(0, 2);

  return (
    <section id="blog-preview" className="my-16">
      <h2 className="text-2xl font-bold text-white text-center mb-4">
        My Digital Sanctuary
      </h2>
      <p className="text-center text-gray-300 mb-8">
        Where I share my authentic thoughts, company updates, and tech explorations
      </p>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
        {recentPosts.map(post => (
          <Link key={post.id} to={`/blog/${post.id}`} className="group">
            <article className="bg-[#1a1a1a] rounded-lg overflow-hidden border border-[#4d4d4d] hover:border-blue-500 transition-all duration-300 transform hover:-translate-y-1 hover:shadow-xl">
              {/* Thumbnail */}
              <div className="relative aspect-video overflow-hidden bg-gray-800">
                {post.headerImage ? (
                  <img
                    src={`/vendor/${post.headerImage}`}
                    alt={post.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-blue-900/30 to-purple-900/30">
                    <div className="text-center">
                      <div className="w-16 h-16 mx-auto mb-2 bg-blue-600 rounded-full flex items-center justify-center">
                        <svg className="w-8 h-8" fill="currentColor" viewBox="0 0 20 20">
                          <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
                        </svg>
                      </div>
                      <p className="text-sm text-gray-400">No Image</p>
                    </div>
                  </div>
                )}
              </div>

              {/* Content */}
              <div className="p-6">
                <h3 className="text-xl font-bold text-white mb-3 line-clamp-2 group-hover:text-blue-400 transition-colors">
                  {post.title}
                </h3>
                
                {post.excerpt && (
                  <p className="text-gray-400 text-sm mb-4 line-clamp-3">
                    {post.excerpt}
                  </p>
                )}

                {/* Metadata */}
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <div className="flex items-center space-x-2">
                    <span>{post.author}</span>
                    <span>•</span>
                    <span>{post.timeToRead}</span>
                  </div>
                  {post.publishedDate && (
                    <span>
                      {new Date(post.publishedDate + "T00:00:00").toLocaleDateString('en-US', {
                        month: 'short',
                        day: 'numeric',
                        year: 'numeric'
                      })}
                    </span>
                  )}
                </div>
              </div>
            </article>
          </Link>
        ))}
      </div>
      <div className="text-center mt-8">
        <Link
          to="/blog"
          className="inline-block bg-transparent backdrop-blur-sm border-2 border-blue-500 text-blue-400 hover:bg-blue-500/10 hover:text-blue-300 font-medium py-3 px-6 rounded-lg transition duration-200"
        >
          Read My Blog
        </Link>
      </div>
    </section>
  );
};

export default BlogSection;